var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDynamicmapIconViewMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.008 8.5a1.607 1.607 0 1 1 0-3.215 1.607 1.607 0 0 1 0 3.215zm4.971 1.305c.603-.92.922-1.98.922-3.07 0-3.16-2.644-5.734-5.892-5.735-3.248.001-5.892 2.574-5.894 5.735 0 1.086.319 2.147.94 3.095L8.008 16l4.971-6.195z"
  })));
}
export default SvgDynamicmapIconViewMap;